import { HttpClient } from '@angular/common/http';
import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  input,
  signal,
  untracked,
} from '@angular/core';
import type { SafeHtml } from '@angular/platform-browser';
import { DomSanitizer } from '@angular/platform-browser';
import { first } from 'rxjs';

@Component({
  selector: 'app-src-icon',
  templateUrl: './source-icon.component.html',
  styleUrl: './source-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SourceIconComponent {
  readonly name = input('');
  readonly size = input('20px');
  PATH_TO_ICON_FOLDER = 'assets/icons/sourceIcons';
  readonly svg = signal<SafeHtml | string>('');
  http = inject(HttpClient);
  sanitizer = inject(DomSanitizer);

  _ = effect(() => {
    const path = `${this.PATH_TO_ICON_FOLDER}/${this.name()}.svg`;
    untracked(() => {
      this.http
        .get(path, { responseType: 'text' })
        .pipe(first())
        .subscribe({
          next: (rawSvg) =>
            this.svg.set(this.sanitizer.bypassSecurityTrustHtml(rawSvg)),
          error: () =>
            console.warn('Icon "' + this.name() + '" not found at ' + path),
        });
    });
  });
}
